import firebase from "@/firebase";

export default {
  namespaced: true,
  state: {
    achievements: [],
  },
  getters: {
    getAchievements(state) {
      return state.achievements;
    },
  },
  mutations: {
    addAchievement(state, data) {
      state.achievements.push(data);
    },
    removeAchievement(state, id) {
      const i = state.achievements.findIndex((a) => a.id === id);
      state.achievements.splice(i, 1);
    },
    setAchievement(state, data) {
      const i = state.achievements.findIndex((a) => a.id === data.id);
      state.achievements[i] = data;
    },
    setAchievements(state, data) {
      state.achievements = data;
    },
  },
  actions: {
    async createAchievement(state, { data, profile }) {
      let media = [];

      if (data.media) {
        const paths = data.media.map(async file => {
          const path = `${profile}/images/${file.name}`;
          const ref = firebase.storage.ref().child(path);
          await ref.put(file);
          return await ref.getDownloadURL();
        });
        media = await Promise.all(paths);
      }

      data = {
        body: data.body,
        created: data.created,
        createdBy: data.createdBy,
        media: media,
        title: data.title
      };

      const achievement = await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("achievements")
        .add(data);
      await achievement.update({ id: achievement.id });
      state.commit("addAchievement", data);
      return achievement.id;
    },
    async deleteAchievement(state, { profile, achievement }) {
      await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("achievements")
        .doc(achievement)
        .delete();
      state.commit("removeAchievement", achievement);
    },
    async listAchievements(state, id) {
      let achievements = [];
      const refs = await firebase.db
        .collection("profiles")
        .doc(id)
        .collection("achievements")
        .get();
      refs.forEach((ref) => achievements.push(ref.data()));
      state.commit("setAchievements", achievements);
    },
    async updateAchievement(state, { data, profile, achievement }) {
      await firebase.db
        .collection("profiles")
        .doc(profile)
        .collection("achievements")
        .doc(achievement)
        .update(data);
      state.commit("setAchievement", data);
    },
  },
};
